import React, { useState, useEffect } from "react";
import Axios from "axios";
import { API_BASE_URL, GET_STORE, UPDATE_POS_TERMINALS } from "../../Config";
import Swal from "sweetalert2";
import SpinLoader from "../loader/SpinLoader";
import PropTypes from "prop-types";

const EditPosTerminal = ({ terminal }) => {
  const [userDataSession, setUserDataSession] = useState({});
  const [stores, setStores] = useState([]);
  const [loading, setLoading] = useState(false);
  const [storeLoading, setStoreLoading] = useState(false);
  useEffect(() => {
    console.log(terminal, " in edit component");
  }, [terminal]);

  const [formData, setFormData] = useState({
    // Id: "",
    // Name: "",
    // Description: "",
    // StoreId: "",
    // TerminalType: "System",
    // LicenseKey: "",
  });

  // Load user session
  useEffect(() => {
    const userDataString = sessionStorage.getItem("userData");
    if (userDataString) {
      const userData = JSON.parse(userDataString);
      setUserDataSession(userData);
    }
  }, []);

  // Load stores
  useEffect(() => {
    if (userDataSession && userDataSession.OrgId) {
      setStoreLoading(true);
      Axios.get(`${API_BASE_URL}${GET_STORE}?OrgId=${userDataSession.OrgId}`)
        .then((response) => {
          if (response.data.Status && response.data.ResultData) {
            setStores(response.data.ResultData);
          } else {
            setStores([]);
          }
          setStoreLoading(false);
        })
        .catch((err) => {
          console.error("Error fetching stores:", err);
          setStores([]);
          setStoreLoading(false);
        });
    }
  }, [userDataSession]);


  useEffect(() => {
    if (terminal) {
      setFormData({
        Id: terminal?.Id || "",
        Name: terminal?.Name || "",
        Description: terminal?.Description || "",
        StoreId: terminal?.StoreId || "",
        TerminalType: terminal?.TerminalType || "System",
        LicenseKey: terminal?.LicenseKey || "",
      });
    }
  }, [terminal]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!formData.Name.trim()) {
      //   setError("Terminal Name is required.");
      Swal.fire({
        icon: "warning",
        title: "Validation Error",
        text: "Terminal Name is required.",
      });
      return;
    }
    if (!formData.StoreId) {
      Swal.fire({
        icon: "warning",
        title: "Validation Error",
        text: "Please select a Store.",
      });
      return;
    }

    setLoading(true);
    
   

    const payload = {
      Id: formData.Id,
      OrgId: userDataSession.OrgId,
      Name: formData.Name.trim(),
      Description: formData.Description.trim(),
      TerminalType: formData.TerminalType,
      StoreId: parseInt(formData.StoreId),
      LicenseKey: formData.LicenseKey.trim(),
      UpdatedBy: userDataSession.UserId,
    };

    Axios.post(`${API_BASE_URL}${UPDATE_POS_TERMINALS}`, payload)
      .then((response) => {
        if (response.data.Status) {
        //   setSuccess("POS Terminal updated successfully!");
          Swal.fire({
            icon: "success",
            title: "Updated!",
            text: "Terminal updated successfully.",
            showConfirmButton: true,
          }).then(()=>{
            window.location.reload();
          });

          // Close offcanvas and refresh list
      
        } else {
        //   setError(response.data.Message || "Failed to update terminal.");
          Swal.fire({
            icon: "error",
            title: "Error",
            text: response.data.Message || "Update failed.",
          });
        }
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error updating terminal:", err);
        // setError("Something went wrong. Please try again.");
        setLoading(false);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Failed to update terminal.",
        });
      });
  };

  return (
    <>
      {loading && <SpinLoader />}
      <style>
        {`
        @media (max-width: 576px) {
          #offcanvasTerminalEdit {
            width: 90% !important;
          }
        }
        @media (min-width: 577px) and (max-width: 992px) {
          #offcanvasTerminalEdit {
            width: 55% !important;
          }
        }
        @media (min-width: 993px) and (max-width: 1440px) {
          #offcanvasTerminalEdit {
            width: 35% !important;
          }
        }
        @media (min-width: 1441px) {
          #offcanvasTerminalEdit {
            width: 20% !important;
          }
        }
        `}
      </style>

      <div
        className="offcanvas offcanvas-end"
        tabIndex="-1"
        id="offcanvasTerminalEdit"
        aria-labelledby="offcanvasTerminalEditLabel"
      >
        <div className="offcanvas-header">
          <h5 className="offcanvas-title" id="offcanvasTerminalEditLabel">
            Edit POS Terminal
          </h5>
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          ></button>
        </div>

        <div className="offcanvas-body">
          <form onSubmit={handleSubmit}>
            <div className="row">
              <div className="col-6 mb-2">
                <label className="form-label">
                  Terminal Name <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  name="Name"
                  value={formData.Name}
                  onChange={handleInputChange}
                  placeholder="Enter terminal name"
                  required
                />
              </div>

              <div className="col-6 mb-2">
                <label className="form-label">
                  Store <span className="text-danger">*</span>
                </label>
                {storeLoading ? (
                  <p>Loading stores...</p>
                ) : (
                  <select
                    className="form-select"
                    name="StoreId"
                    value={formData.StoreId}
                    onChange={handleInputChange}
                    required
                  >
                    <option value="">-- Select Store --</option>
                    {stores.map((store) => (
                      <option key={store.Id} value={store.Id}>
                        {store.Name}
                      </option>
                    ))}
                  </select>
                )}
              </div>

              <div className="col-6 mb-2">
                <label className="form-label">Terminal Type</label>
                <select
                  className="form-select"
                  name="TerminalType"
                  value={formData.TerminalType}
                  onChange={handleInputChange}
                >
                  <option value="System">System</option>
                  <option value="Tab">Tab</option>
                </select>
              </div>

              <div className="col-6 mb-2">
                <label className="form-label">License Key</label>
                <input
                  type="text"
                  className="form-control"
                  name="LicenseKey"
                  value={formData.LicenseKey}
                  onChange={handleInputChange}
                  placeholder="Enter license key"
                />
              </div>

              <div className="col-12">
                <label className="form-label">Description</label>
                <textarea
                  className="form-control"
                  name="Description"
                  rows="3"
                  value={formData.Description}
                  onChange={handleInputChange}
                  placeholder="Enter description"
                ></textarea>
              </div>
            </div>

            <div className="d-flex justify-content-end p-3">
              <button
                type="submit"
                className="btn btn-primary me-2"
                disabled={loading}
              >
                {loading ? "Updating..." : "Update"}
              </button>
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="offcanvas"
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default EditPosTerminal;
EditPosTerminal.propTypes = {
  terminal: PropTypes.object.isRequired,
};
